"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var DatetimeInputContext_1 = require("./DatetimeInputContext");
var getInitialShownMonth = function (value) {
    if (value === void 0) { value = new Date(); }
    return {
        month: value.getMonth(),
        year: value.getFullYear()
    };
};
exports.convert12To24HourFormat = function (hours, isAM) {
    if (hours === 12) {
        return isAM ? 0 : 12;
    }
    return isAM ? hours : hours + 12;
};
exports.useDatetimeSelectorViewModel = function (_a) {
    var value = _a.value, _b = _a.startDatetime, startDatetime = _b === void 0 ? new Date(0) : _b, _c = _a.endDatetime, endDatetime = _c === void 0 ? new Date(9999, 11, 31) : _c, isDisabledDate = _a.isDisabledDate, _d = _a.withTime, withTime = _d === void 0 ? false : _d, _e = _a.is12Hours, is12Hours = _e === void 0 ? false : _e, manualCloseMode = _a.manualCloseMode, onSelect = _a.onSelect, onRequestClose = _a.onRequestClose, onDateChange = _a.onDateChange;
    var now = react_1.useContext(DatetimeInputContext_1.DatetimeInputContext).getNowTime();
    var initialDraftHours = value ? value.getHours() : null;
    if (value && is12Hours && value.getHours() > 12) {
        initialDraftHours = value.getHours() - 12;
    }
    if (value && is12Hours && value.getHours() === 0) {
        initialDraftHours = 12;
    }
    var _f = react_1.useState(getInitialShownMonth(value || now)), shownMonth = _f[0], setShownMonth = _f[1];
    var _g = react_1.useState(shownMonth), monthSelectorValue = _g[0], setMonthSelectorValue = _g[1];
    var _h = react_1.useState(false), monthSelectMode = _h[0], setMonthSelectMode = _h[1];
    var _j = react_1.useState(value || undefined), draftValue = _j[0], setDraftValue = _j[1];
    var _k = react_1.useState(initialDraftHours), draftHours = _k[0], setDraftHours = _k[1];
    var _l = react_1.useState(value ? value.getMinutes() : null), draftMinutes = _l[0], setDraftMinutes = _l[1];
    var _m = react_1.useState(!(value && value.getHours() >= 12)), draftIsAmTimePeriod = _m[0], setDraftIsAmTimePeriod = _m[1];
    var _o = react_1.useState({
        dateValue: false,
        hours: false,
        minutes: false
    }), errorState = _o[0], setErrorState = _o[1];
    var canApplyShownMonth = !!monthSelectorValue.year && typeof monthSelectorValue.month === 'number';
    var deactivate = function () {
        if (onRequestClose) {
            onRequestClose();
        }
    };
    var onSelectDay = function (day) {
        setShownMonth({ year: day.getFullYear(), month: day.getMonth() });
        setErrorState(__assign(__assign({}, errorState), { dateValue: false }));
        onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(day);
        if (withTime || manualCloseMode) {
            setDraftValue(day);
            return;
        }
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(day);
        deactivate();
    };
    var onApplyMonthSelector = function () {
        if (typeof monthSelectorValue.month === 'number' &&
            typeof monthSelectorValue.year === 'number') {
            var shownMonth_1 = {
                year: monthSelectorValue.year,
                month: monthSelectorValue.month
            };
            setShownMonth(shownMonth_1);
            setMonthSelectMode(false);
        }
    };
    var onCancelMonthSelector = function () {
        setMonthSelectMode(false);
    };
    var onRequestMonthSelector = function () {
        setMonthSelectMode(true);
        setErrorState(__assign(__assign({}, errorState), { dateValue: false }));
    };
    var isMonthDisabled = function (_a) {
        var year = _a.year, month = _a.month;
        var lessThanStartDatetime = startDatetime
            ? new Date(year, month, 31, 23, 59, 59) < startDatetime
            : false;
        var moreThanEndDatetime = endDatetime
            ? new Date(year, month, 1, 0, 0, 0) > endDatetime
            : false;
        if (lessThanStartDatetime || moreThanEndDatetime) {
            return true;
        }
        if (!isDisabledDate) {
            return false;
        }
        var countMonthDays = new Date(year, month + 1, 0).getDate();
        for (var day = 1; day <= countMonthDays; day++) {
            if (!isDisabledDate(new Date(year, month, day))) {
                return false;
            }
        }
        return true;
    };
    var isYearDisabled = function (year) {
        var lessThanStartDatetime = startDatetime
            ? new Date(year, 11, 31, 23, 59, 59) < startDatetime
            : false;
        var moreThanEndDatetime = endDatetime
            ? new Date(year, 0, 1, 0, 0, 0) > endDatetime
            : false;
        if (lessThanStartDatetime || moreThanEndDatetime) {
            return true;
        }
        if (!isDisabledDate) {
            return false;
        }
        for (var month = 0; month <= 11; month++) {
            if (!isMonthDisabled({ year: year, month: month })) {
                return false;
            }
        }
        return true;
    };
    var onMonthSelectorSelectValue = function (newValue) {
        var newMonth;
        var newYear;
        if (newValue.month === undefined) {
            newMonth = monthSelectorValue.month;
        }
        if (newValue.month || newValue.month === 0) {
            newMonth = newValue.month;
        }
        if (newValue.year === undefined) {
            newYear = monthSelectorValue.year;
        }
        if (newValue.year) {
            newYear = newValue.year;
        }
        var result = {
            month: newMonth,
            year: newYear
        };
        if (result.year &&
            typeof monthSelectorValue.month === 'number' &&
            isMonthDisabled({ month: monthSelectorValue.month, year: result.year })) {
            result.month = undefined;
        }
        setMonthSelectorValue(result);
    };
    var onHoursChange = function (hours) {
        setDraftHours(hours);
        setErrorState(__assign(__assign({}, errorState), { hours: false }));
    };
    var onMinutesChange = function (minutes) {
        setDraftMinutes(minutes);
        setErrorState(__assign(__assign({}, errorState), { minutes: false }));
    };
    var onTimePeriodChange = function (isAmTimePeriod) {
        setDraftIsAmTimePeriod(isAmTimePeriod);
    };
    var onApply = function () {
        setErrorState({
            dateValue: !draftValue,
            hours: draftHours === null,
            minutes: draftMinutes === null
        });
        if (onSelect && draftValue && withTime && draftHours !== null && draftMinutes !== null) {
            var newDate = new Date(draftValue.getFullYear(), draftValue.getMonth(), draftValue.getDate(), is12Hours ? exports.convert12To24HourFormat(draftHours, draftIsAmTimePeriod) : draftHours, draftMinutes, 0);
            onSelect(newDate);
            onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
            return;
        }
        if (onSelect && draftValue && !withTime) {
            onSelect(draftValue);
            onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
            return;
        }
    };
    var isTodayDisabled = function () {
        var currentYear = now.getFullYear();
        var currentMonth = now.getMonth();
        var currentDay = now.getDate();
        var ceilDate = new Date(currentYear, currentMonth, currentDay, 23, 59, 59);
        var floorDate = new Date(currentYear, currentMonth, currentDay, 0, 0, 0);
        var lessThanStartDatetime = ceilDate < startDatetime;
        var moreThanEndDatetime = floorDate > endDatetime;
        return lessThanStartDatetime || (isDisabledDate === null || isDisabledDate === void 0 ? void 0 : isDisabledDate(now)) || moreThanEndDatetime;
    };
    var onTodaySelect = function () {
        onSelectDay(now);
    };
    return {
        shownMonth: shownMonth,
        monthSelectorValue: monthSelectorValue,
        monthSelectMode: monthSelectMode,
        canApplyShownMonth: canApplyShownMonth,
        isYearDisabled: isYearDisabled,
        isMonthDisabled: isMonthDisabled,
        draftValue: draftValue,
        draftIsAmTimePeriod: draftIsAmTimePeriod,
        draftHours: draftHours,
        draftMinutes: draftMinutes,
        is12Hours: is12Hours,
        onSelectDay: onSelectDay,
        onRequestMonthSelector: onRequestMonthSelector,
        onApplyMonthSelector: onApplyMonthSelector,
        onCancelMonthSelector: onCancelMonthSelector,
        onMonthSelectorSelectValue: onMonthSelectorSelectValue,
        onHoursChange: onHoursChange,
        onMinutesChange: onMinutesChange,
        onTimePeriodChange: onTimePeriodChange,
        onApply: onApply,
        deactivate: deactivate,
        errorState: errorState,
        isTodayDisabled: isTodayDisabled,
        onTodaySelect: onTodaySelect
    };
};
//# sourceMappingURL=hooks.js.map